import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function createMtrTemplate(payload) {
  const { data: raw } = await request.post('/mtr-template', keysToSnake(payload));
  return parseVer4DetailResponse(raw);
}
